import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import BackendClient from "../../BackendClient";
import Loader from "../../Components/Loading";
import DateFormat from "../../helpers/DateFormat";

const mapStateToProps = ({ identity }) => ({
  identity
});

class NewsView extends Component {
  state = {
    isFetched: false,
    isFetching: false,
    data: null
  };

  componentWillUnmount() {
    this.isCancelled = true;
  }

  componentDidMount = () => {
    const { id } = this.props.match.params || {};
    const { isFetched, isFetching } = this.state;
    if (!(isFetched && isFetching)) {
      !this.isCancelled &&
        this.setState({ isFetched: false, isFetching: true });
      !this.isCancelled &&
        BackendClient.getArticle(id)
          .fetchJson()
          .then(data => {
            if (!data) {
              return this.props.history.replace("/page-not-found");
            }
            !this.isCancelled &&
              this.setState({ isFetched: true, isFetching: false, data });
          });
    }
  };

  render() {
    const { isFetched, isFetching, data } = this.state;
    let logo;
    if (!this.props.identity.id) {
      logo = (
        <div className="logo">
          <Link to="/">
            <img src="/images/logo.png" alt="" />
          </Link>
        </div>
      );
    }
    let content;
    if (!isFetched && isFetching) {
      content = <Loader loading />;
    } else {
      const { title, published_at, body: __html } = data || {};
      const dt = DateFormat.dateFromEpoch( published_at);
      content = (
        <Fragment>
          <h1 className="text-center news-item-title">{title}</h1>
          <div className="news-item-date">{dt && dt.ddmmyyyy()}</div>
          <div
            className="news-item-body"
            dangerouslySetInnerHTML={{ __html }}
          />
        </Fragment>
      );
    }
    return (
      <Fragment>
        {logo}
        {content}
      </Fragment>
    );
  }
}

export default withRouter(connect(mapStateToProps)(NewsView));



// WEBPACK FOOTER //
// ./src/containers/news/view.jsx